import React from 'react';
import Dialog from 'relements/build/esm/overlays/dialog';
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';

const PiiParameterModal = ({ active, onClose, piiParameters }) => {
  return (
    <Dialog
      onClose={onClose}
      active={active}
      title="Action Saved — PII Parameters Detected"
      primaryAction={onClose}
      primaryActionText="Understood"
      secondaryActionText={null}
      dialogStyles={{ width: '600px', padding: '16px' }}
    >
      <Box flexDirection="column">
        <Text>
          We detected parameters that may capture Personally Identifiable
          Information (PII) and automatically marked them for protection:
        </Text>
        <ul>
          {piiParameters.map((param) => {
            return <li>{param}</li>;
          })}
        </ul>
        <Text>
          These parameters will now appear as{' '}
          <Text
            style={{
              padding: '0 8px',
              backgroundColor: 'lightgray',
              borderRadius: '4px',
            }}
          >
            **Masked**
          </Text>{' '}
          in the Action Analysis Dashboard to keep sensitive data hidden.
        </Text>
      </Box>
    </Dialog>
  );
};

export default PiiParameterModal;
